module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./node_modules/xhr2/lib/browser.js
// module id = 42
// module chunks = 0